<div class="card p-fluid">
    <div class="flex justify-content-between flex-wrap">
        <div class="flex justify-content-center mb-3">
            <label class="card-heading uppercase" translate>lbl_details</label>
        </div>
        @if(orderStatus === 'RETURN_ORDER' && configService.isTenantAdmin()) {
        <div class="flex align-items-center mb-3">
            <button pButton type="button" [label]="'Download Return Report'" (click)="downloadReturnReport()"></button>
        </div>
        }
    </div>
    @if(details && details.fields){


    <div class="grid">
        <div class="col-4 pt-1">
            <label class="detail-heading" translate>{{cs.getLabelValue('order.fields.order_status.label',
                attributeLabels,
                'order_status')}}</label>
        </div>
        <div class="col-8 pb-1">
            <span class="border-round-md status-box"
                [ngStyle]="{ 'background-color': orderStatusColor }">
                <label class="detail-value" [style.color]="orderStatus === 'NEW_ORDER' ? '#ffffff' : '#000'" [style.color.important]="true">{{ (displayOrderStatus ?? attributeValues['order_status']) || '--' }}</label>
            </span>
        </div>
    </div>
    <hr class="hr-line">
    <div class="grid">
        <div class="col-4 pt-1">
            <label class="detail-heading" translate>{{cs.getLabelValue('order.fields.order_number.label',
                attributeLabels,
                'order_number')}}</label>
        </div>
        <div class="col-8 pb-1">

            <label class="detail-value">{{ attributeValues['order_number'] ?
                attributeValues['order_number'] :
                '--' }}</label>
        </div>
    </div>
    <hr class="hr-line">

    <div class="grid">
        <div class="col-4 pt-1">
            <label class="detail-heading" translate>{{cs.getLabelValue('order.fields.protocol_id.label',
                attributeLabels,
                'protocol_id')}}</label>
        </div>
        <div class="col-8 pb-1">

            <label class="detail-value">{{ protocolAttrValue ?
                protocolAttrValue :
                '--' }}</label>
        </div>
    </div>
    <hr class="hr-line">

    <div class="grid">
        <div class="col-4 pt-1">
            <label class="detail-heading" translate>{{cs.getLabelValue('order.fields.delivery_address.label',
                attributeLabels,
                'delivery_address')}}</label>
        </div>
        <div class="col-8 pb-1">

            <label class="detail-value">{{ attributeValues['delivery_address'] ?
                attributeValues['delivery_address'] :
                '--' }}</label>
        </div>
    </div>
    <hr class="hr-line">

    <div class="grid">
        <div class="col-4 pt-1">
            <label class="detail-heading" translate>{{cs.getLabelValue('order.fields.date_of_dispatch.label',
                attributeLabels,
                'date_of_dispatch')}}</label>
        </div>
        @if(!showDispatchDateCalendar){
        <div class="col-8 pb-1">

            <label class="detail-value">{{ attributeValues['date_of_dispatch'] ?
                metaDataService.formatDateTimeOnTZ(attributeValues['date_of_dispatch'], 'MMM D, YYYY') :
                '--' }}</label>

        </div>
        }

        @if(showDispatchDateCalendar){

        <div class="col-8  pb-1 pt-0">
            <div style="display: flex; align-items: center; gap: 10px;">
                <p-calendar [(ngModel)]="pendingDateOfDispatchModel" [showIcon]="true" inputId="buttondisplay"
                    [style]="{width: '100%'}" [dateFormat]="'dd/mm/yy'" appendTo="body"
                    [placeholder]="'lbl_select_date' | translate" />
                <button pButton type="button" [style]="{width: '100px'}" [label]="'lbl_save' | translate"
                    (click)="onSaveDate()"></button>
            </div>

        </div>
        }

    </div>
    <hr class="hr-line">


    <div class="grid">
        <div class="col-4 pt-1">
            <label class="detail-heading" translate>{{cs.getLabelValue('order.fields.created_by.label',
                attributeLabels,
                'created_by')}}</label>
        </div>
        <div class="col-8 pb-1">

            <label class="detail-value">{{ attributeValues['created_by'] ?
                attributeValues['created_by'] :
                '--' }}</label>
        </div>
    </div>
    <hr class="hr-line">


    <div class="grid">
        <div class="col-4 pt-1">
            <label class="detail-heading" translate>{{cs.getLabelValue('order.fields.entity_created_at.label',
                attributeLabels,
                'entity_created_at')}}</label>
        </div>
        <div class="col-8 pb-1">

            <label class="detail-value">{{ attributeValues['entity_created_at'] ?
                metaDataService.formatDateTimeOnTZ(attributeValues['entity_created_at'], 'MMM D, YYYY'):
                '--' }}</label>
        </div>
    </div>
    <hr class="hr-line">

    <div class="grid">
        <div class="col-4 pt-1">
            <label class="detail-heading" translate>{{cs.getLabelValue('order.fields.created_by_role.label',
                attributeLabels,
                'created_by_role')}}</label>
        </div>
        <div class="col-8 pb-1">

            <label class="detail-value">{{ attributeValues['created_by_role'] ?
                attributeValues['created_by_role'] :
                '--' }}</label>
        </div>
    </div>
    <hr class="hr-line">


    <div class="grid">
        <div class="col-4 pt-1">
            <label class="detail-heading" translate>{{cs.getLabelValue('order.fields.expected_delivery_date.label',
                attributeLabels,
                'expected_delivery_date')}}</label>
        </div>
        <div class="col-8 pb-1">

            <label class="detail-value">{{ attributeValues['expected_delivery_date'] ?
                metaDataService.formatDateTimeOnTZ(attributeValues['expected_delivery_date'], 'MMM D, YYYY') :
                '--' }}</label>
        </div>
    </div>
    <hr class="hr-line">

    @if(orderStatus === 'ORDER_PARTIALLY_RECEIVED'){
    <div class="grid">
        <div class="col-4 pt-1">
            <label class="detail-heading" translate>{{cs.getLabelValue('order.fields.proof_image.label',
                attributeLabels,
                'proof_image')}}</label>
        </div>
        <div class="col-8 pb-1">

            @for (item of proofImageFiles; track item.signedUrl) {
            <div class="download-container flex align-items-center justify-content-between mb-3">
                <div class="download-info flex align-items-center">
                    <img class="inline-block cursor-pointer flex-shrink-0" [src]="openLogo" alt="">
                    <span>{{ item.originalFileName }}</span>
                </div>
                <a (click)="downloadFile(item.signedUrl, item.originalFileName)">
                    <i
                        class="{{miIcons.DOWNLOAD}} download-icon cursor-pointer inline-block wh-14 mr-2"></i>
                </a>
            </div>

            }
        </div>
    </div>
    <hr class="hr-line">
    }
    }

</div>
<p-dialog [(visible)]="showConfirmDateDialog" [modal]="true" [closable]="true" [responsive]="true"
    [style]="{width: '550px'}" (onHide)="onCancelDateDialog()">
    <p-header translate>lbl_confirm</p-header>
    <span class="p-d-flex p-jc-center p-ai-center" style="min-height: 100px;">
        <p class="m-3 ml-0" translate>lbl_dispatch_date</p>
    </span>

    <p-footer>
        <button type="button" pButton [label]="'lbl_cancel' | translate" class="noChange  cancel-order-btn"
            (click)="onCancelDateDialog()"></button>
        <button type="button" pButton [label]="'lbl_confirm' | translate" class="discard"
            (click)="onConfirmDateChange()"></button>
    </p-footer>
</p-dialog>